// owner: social-graph domain agent
import { z } from 'zod';
import { EpochMsSchema, PaginationQuerySchema, UlidSchema, paginated } from './common';

export const PersonRefSchema = z.object({
  userId: UlidSchema,
  handle: z.string().nullable(),
  displayName: z.string(),
  avatarUrl: z.string().nullable(),
  headline: z.string(),
});
export type PersonRef = z.infer<typeof PersonRefSchema>;

export const ConnectionListQuerySchema = PaginationQuerySchema.extend({
  status: z.enum(['accepted', 'pending_in', 'pending_out']).default('accepted'),
});
export const ConnectionSchema = z.object({
  user: PersonRefSchema,
  status: z.enum(['pending', 'accepted', 'declined']),
  direction: z.enum(['in', 'out']),
  note: z.string(),
  createdAt: EpochMsSchema,
  updatedAt: EpochMsSchema,
});
export type Connection = z.infer<typeof ConnectionSchema>;
export const ConnectionListSchema = paginated(ConnectionSchema);

export const ConnectionRequestSchema = z
  .object({
    userId: UlidSchema.optional(),
    handle: z.string().trim().min(1).max(60).optional(),
    note: z.string().trim().max(300).default(''),
  })
  .refine(
    (v) => Boolean(v.userId) !== Boolean(v.handle),
    'Provide exactly one of userId or handle',
  );
export const UserIdParamsSchema = z.object({ userId: UlidSchema });
export const OrgIdParamsSchema = z.object({ orgId: UlidSchema });

export const FollowSchema = z.object({
  kind: z.enum(['user', 'org']),
  targetId: z.string(),
  createdAt: EpochMsSchema,
  user: PersonRefSchema.nullable(),
});
export const FollowListSchema = paginated(FollowSchema);
export const FollowStateSchema = z.object({ following: z.boolean() });
export const FollowListQuerySchema = PaginationQuerySchema;
export const FollowerListSchema = paginated(PersonRefSchema);

// ------------------------------------------------------------------ block/mute (A05)
export const BlockStateSchema = z.object({ blocked: z.boolean() });
export const MuteStateSchema = z.object({ muted: z.boolean() });
export const BlockListSchema = paginated(PersonRefSchema);
export const MuteListSchema = paginated(PersonRefSchema);

// ------------------------------------------------------------------ PYMK (A16/A17)
export const PymkItemSchema = z.object({
  user: PersonRefSchema,
  mutualCount: z.number().int().nonnegative(),
  reason: z.string(),
});
export const PymkListSchema = paginated(PymkItemSchema);
export const PymkQuerySchema = z.object({ limit: z.coerce.number().int().min(1).max(50).default(20) });
